export default __webpack_public_path__ + "static/img-richard-lund-de18969c18943c111ceed200c9963437.png";